import ChargesTable from './ChargesTable';

export default ChargesTable;
